.discord-header {
	display: flex;
	flex-direction: row;
	max-height: 5rem;
	padding: 0.5rem;
	gap: 0.5rem;
	border-bottom: 1px solid rgba(79, 84, 92, 0.48);
}

.discord-header-icon {
	float: left;
	width: 5rem;
}

.discord-header-icon > div {
	background-color: rgb(79, 84, 92);
	border-radius: 50%;
	width: 5rem;
	height: 5rem;
	text-align: center;
	align-items: center;
	justify-content: center;
	display: flex;
	font-size: xx-large;
}

.discord-header-icon > img {
	border-radius: 50%;
	width: auto;
	height: 100%;
}

.discord-header-text {
	flex-grow: 1;
}

.discord-header-text-guild {
	font-size: 1.5rem;
	font-weight: bold;
}
